module.exports = __webpack_public_path__ + "static/team.85634c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team.jpg
// module id = 1511
// module chunks = 169858455373905